import { Link } from "@inertiajs/react";
import { PublicNavbar } from "./public-navbar";

function BrandLogo({ className }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden>
      <defs>
        <linearGradient id="legal-brand-logo-gradient" x1="8" y1="6" x2="56" y2="58" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#22d3ee" />
          <stop offset="0.5" stopColor="#38bdf8" />
          <stop offset="1" stopColor="#34d399" />
        </linearGradient>
      </defs>
      <rect x="4" y="4" width="56" height="56" rx="16" fill="#020617" stroke="url(#legal-brand-logo-gradient)" strokeWidth="3" />
      <path
        d="M17 45L30.5 17.5a2 2 0 013 0L47 45a2 2 0 01-1.8 2.9H18.8A2 2 0 0117 45z"
        fill="none"
        stroke="url(#legal-brand-logo-gradient)"
        strokeWidth="3.2"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="33" r="5.5" fill="url(#legal-brand-logo-gradient)" />
    </svg>
  );
}

export function LegalLayout({ auth, eyebrow, title, intro, children }) {
  return (
    <div className="min-h-screen bg-black text-white">
      <PublicNavbar auth={auth} />

      <main className="mx-auto w-full max-w-[1140px] px-4 py-10 md:px-6 md:py-14">
        <section className="rounded-3xl border border-slate-800 bg-[radial-gradient(circle_at_top,rgba(34,211,238,.12),transparent_40%),radial-gradient(circle_at_bottom_right,rgba(99,102,241,.14),transparent_36%),rgba(2,6,23,.86)] p-6 shadow-[0_24px_70px_rgba(2,6,23,.45)] md:p-8">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-cyan-200">{eyebrow}</p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight text-white md:text-5xl">{title}</h1>
          <p className="mt-4 max-w-3xl text-sm leading-7 text-slate-300 md:text-base">{intro}</p>
        </section>

        <section className="mt-6 space-y-4">{children}</section>
      </main>

      <footer className="border-t border-slate-800 bg-slate-950 py-10 text-slate-300">
        <div className="mx-auto flex w-full max-w-[1140px] flex-col items-center px-4 text-center md:px-6">
          <div className="flex items-center gap-2">
            <BrandLogo className="h-8 w-8" />
            <p className="text-base font-semibold tracking-tight text-white">UGC Persona</p>
          </div>
          <p className="mt-1 text-xs text-slate-400">Your AI influencer. Your brand. Infinite content.</p>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-4 text-sm text-slate-400">
            <Link href="/docs" className="transition hover:text-white">
              Docs
            </Link>
            <Link href="/terms" className="transition hover:text-white">
              Terms & Conditions
            </Link>
            <Link href="/privacy-cookies" className="transition hover:text-white">
              Privacy & Cookies
            </Link>
            <a href="mailto:hello@ugcpersona.com" className="transition hover:text-white">
              Contact
            </a>
          </div>
          <p className="mt-4 text-xs text-slate-500">© {new Date().getFullYear()} UGC Persona. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-950/95 p-5 shadow-[0_14px_40px_rgba(2,6,23,.36)] md:p-6">
      <h2 className="text-xl font-semibold tracking-tight text-white md:text-2xl">{title}</h2>
      <div className="mt-3 space-y-3 text-sm leading-7 text-slate-300 md:text-[15px]">{children}</div>
    </section>
  );
}

export function LegalList({ items }) {
  return (
    <ul className="space-y-2">
      {items.map((item) => (
        <li key={item} className="flex items-start gap-3">
          <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-cyan-300" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
